import { DocsTableContents, DocsTableContentsProps, DocsTableRefProps } from "./DocsTableContents";
import { DocsTableFilterGroup } from "./DocsTableFilterGroup/DocsTableFilterGroup";
import { DocsTablePagination } from "./DocsTablePagination";

export type DocsTableSizeType = "small" | "medium";

export type DocsTableProps = {
  children: React.ReactNode;
};

export function DocsTable({ children }: DocsTableProps) {
  return <>{children}</>;
}

DocsTable.FilterGroup = DocsTableFilterGroup;
DocsTable.Contents = DocsTableContents as <T>(
  props: DocsTableContentsProps<T> & { ref?: React.Ref<DocsTableRefProps> }
) => React.ReactElement | null;
DocsTable.Pagination = DocsTablePagination;
